<template>
  <div class="pdt-20px">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionCommande.ordreTravail.title')}}
        </p>
      </header>
      <a ref="lienDownload"></a>
      <div class="card-content">
        <div class="columns is-multiline level">
          <div class="column is-narrow level-left">
          </div>
          <div class="column is-narrow level-right">
            <button class="button is-addOrEdit"
                    @click="exportExcel()">
              {{$t('editionCommande.ordreTravail.actions.exportExcel') }}
            </button>
            <b-tooltip
              :active="!ordreTravails.length"
              :label="$t('editionCommande.ordreTravail.validation.noOt')"
              position="is-left"
              type="is-info">
              <qd-button v-if="moduleAffixeMobileOTAffichageActive"
                :disabled="!ordreTravails.length"
                @click="downloadZipPj()"
                class="button is-addOrEdit mgl-2">
                {{$t('editionCommande.ordreTravail.actions.exportPicture') }}
              </qd-button>
            </b-tooltip>
            <b-tooltip
              :active="!ordreTravails.length"
              :label="$t('editionCommande.ordreTravail.validation.noOt')"
              position="is-left"
              type="is-info">
              <qd-button v-if="moduleAffixeMobileOTAffichageActive"
                    class="button is-addOrEdit mgl-2"
                    :disabled="!ordreTravails.length"
                    @click="diaporama()">
                {{$t('editionCommande.ordreTravail.actions.diaporama') }}
              </qd-button>
            </b-tooltip>
          </div>
        </div>
        <v-client-table class="mgt-20px" :columns="columns" :options="options"
                        ref="tableCommentaire"
                        :data="ordreTravails">
          <div slot="code" slot-scope="props">
            <router-link-blank v-if="afficherLien"
              :to="{ name: 'c.logistique.ordre_travail-affichage',
                    params: { id: props.row.id }}"
              :message="props.row.code"/>
              <span v-else> {{ props.row.code }} </span>
          </div>
          <div slot="dateAffichage" slot-scope="props">
            {{ props.row.dateAffichage | formatDate }}
          </div>
          <div slot="etat" slot-scope="props">
            {{ $t(getLibelleEtat(props.row.etat))}}
          </div>
          <div slot="nFacesPrevuesCmd" slot-scope="props">
            <b-tooltip
              type="is-primary"
              position="is-left"
              :label="$t('editionCommande.ordreTravail.tooltip.facePrevue',{
                nFacesPrevuesCmd: props.row.nFacesPrevuesCmd,
                nFacesPrevuesTotal: props.row.nFacesPrevuesTotal}
              )">
              {{ props.row.nFacesPrevuesCmd }} ({{ props.row.nFacesPrevuesTotal }})
            </b-tooltip>
          </div>
          <div slot="nFacesAfficheesCmd" slot-scope="props">
            <b-tooltip
              type="is-primary"
              position="is-left"
              :label="$t('editionCommande.ordreTravail.tooltip.faceAffiche',{
                nFacesAfficheesCmd: props.row.nFacesAfficheesCmd,
                nFacesAfficheesTotal: props.row.nFacesAfficheesTotal}
              )">
              {{ props.row.nFacesAfficheesCmd }} ({{ props.row.nFacesAfficheesTotal }})
            </b-tooltip>
          </div>
          <div slot="nGrattageEffectuesCmd" slot-scope="props">
            <b-tooltip
              type="is-primary"
              position="is-left"
              :label="$t('editionCommande.ordreTravail.tooltip.grattage',{
                nGrattageEffectuesCmd: props.row.nGrattageEffectuesCmd,
                nGrattageEffectuesTotal: props.row.nGrattageEffectuesTotal}
              )">
              {{ props.row.nGrattageEffectuesCmd }} ({{ props.row.nGrattageEffectuesTotal }})
            </b-tooltip>
          </div>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, NO_PAGINATION, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  LISTE_ETAT_ORDRE_TRAVAIL,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import exportExcel from '@/api/exportExcel';
import { getZipPjOtAffichage } from '@/api/commande';
import messageErreur from '@/services/general/messageErreur';
import messageInformation from '@/services/general/messageInformation';
import { EXPORT_EXCEL_RETOUR_AFFICHAGE } from '@/configuration/commande/commandeConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import edition from '@/api/edition/index';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { TYPE_DONNEE_DIAPORAMA } from '@/configuration/catalogue/produitConf';
import validationEdition from '@/services/general/validation/validationRetourEdition';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'informationOrdreTravailIntoCommande',
  props: {
    ordreTravails: {
      type: Array,
      required: false,
    },
    afficherLien: {
      type: Boolean,
      required: false,
      default: true,
    },
    detailCommande: {
      type: Object,
      required: false,
    },
  },
  data() {
    return ({
      constantes: {
        TYPE_PDF,
        TYPE_DONNEE_DIAPORAMA,
      },
    });
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('editionCommande.ordreTravail.tab.ot'),
          dateAffichage: this.$i18n.t('editionCommande.ordreTravail.tab.dateAffichage'),
          listeAffichage: this.$i18n.t('editionCommande.ordreTravail.tab.listeAffichage'),
          nomAfficheur: this.$i18n.t('editionCommande.ordreTravail.tab.afficheur'),
          etat: this.$i18n.t('editionCommande.ordreTravail.tab.etat'),
          nFacesPrevuesCmd: this.$i18n.t('editionCommande.ordreTravail.tab.facePrevue'),
          nFacesAfficheesCmd: this.$i18n.t('editionCommande.ordreTravail.tab.faceAffiche'),
          nGrattageEffectuesCmd: this.$i18n.t('editionCommande.ordreTravail.tab.nbgrattage'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: ['code', 'dateAffichage', 'listeAffichage', 'nomAfficheur', 'etat', 'nFacesPrevuesCmd', 'nFacesAfficheesCmd', 'nGrattageEffectuesCmd'],
      };
    },
    columns() {
      return ['code', 'dateAffichage', 'listeAffichage', 'nomAfficheur', 'etat', 'nFacesPrevuesCmd', 'nFacesAfficheesCmd', 'nGrattageEffectuesCmd'];
    },
    moduleAffixeMobileOTAffichageActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.affixeMobileOTAffichage.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getLibelleEtat(etat) {
      const etatFind = LISTE_ETAT_ORDRE_TRAVAIL.find((devisCommandeEtat) => {
        return devisCommandeEtat.code === etat;
      });
      return etatFind ? etatFind.libelle : '';
    },
    async exportExcel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const lastPayload = {
          SkipCount: 0,
          MaxResultCount: NO_PAGINATION,
          Query: {
            // societeId: this.detailCommande.generalInfos.societeId,
            affectationLogistiqueLigneCommandeIds: this.detailCommande.lignesCommande
              .map((ligneCommande) => ligneCommande.id),
          },
        };
        const response = await exportExcel({
          typeDonnee: EXPORT_EXCEL_RETOUR_AFFICHAGE,
          typeExport: null,
          filtres: lastPayload,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async diaporama() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.detailCommande.lignesCommande.map(l => l.produitId)[0]],
          extension: this.constantes.TYPE_PDF,
          typeDonnee: this.constantes.TYPE_DONNEE_DIAPORAMA,
          parametresAdditionnels: {
            typeSource: 'retourAffichage',
            societeId: this.societeActiveId,
            commandeId: this.detailCommande.id,
            isCBA: false,
          },
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (e.response?.data) {
          const messageErreur = [];
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEdition(response, messageErreur);
          messageInformation(messageErreur.map(m => this.$t(m.message)).join('\n'));
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async downloadZipPj() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await getZipPjOtAffichage(this.detailCommande.id);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        messageInformation(this.$i18n.t('editionCommande.ordreTravail.validation.noPicture'));
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.affixeMobileOTAffichage.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
